import {AxiosResponse} from 'axios'

import Client from 'core/api/client'
import {
  IPatientJson,
  IPrescriptionData,
  ITreatmentReportAdherenceData,
  ITreatmentReportPatientData,
} from 'core/api/patient'
import {DeviceType} from '../models'
import { IErrorResponse } from './error'

/**
 * Represents a single study participant's informational data, as seen by a study coordinator.
 */
export interface IStudyParticipantResult extends ITreatmentReportAdherenceData, ITreatmentReportPatientData {
  /** The study participant's access code */
  accessCode: string

  /** The study participant's age */
  age: number

  /** The id of the participant */
  id: string

  /** Prescription information for each prescription assigned to the patient */
  prescriptions: IPrescriptionData[]

  /** The study participant's subject id */
  subjectIdentifier: string

  /** The type of the study participant's assigned device */
  deviceType?: DeviceType

  /** The patient associated with the study participant */
  patient: IPatientJson
}

/**
 * Expected response body from GET /study/participants endpoint
 */
export interface IGetSubjectsSuccessResponse {
  participants: { [key: string]: IStudyParticipantResult }
}


type IGetSubjectsResponseBody = IGetSubjectsSuccessResponse | IErrorResponse;

/**
 * Expected response from GET /study/participants endpoint
 */
export interface IGetSubjectsResponse extends AxiosResponse {
  data: IGetSubjectsResponseBody
}

/**
 * GET /study/participants
 */
export function getSubjects(token: string): Promise<IGetSubjectsResponse> {
  const headers = { Authorization: `Bearer ${token}` }
  return Client.get('/study/participants?dailyUsages=false', { headers, validateStatus: () => true })
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_coordinator/getSubjects.ts